// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-edit-page {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
    font-family: 'Noto Sans KR', sans-serif;
    color: #333;
}

.uip-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.uip-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.uip-main-title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
}

/* Progress Bar */
.uip-progress-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    padding: 20px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

.uip-progress-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ccc;
    font-size: 14px;
    width: 150px;
    text-align: center;
}

.uip-progress-step.active {
    color: #d9534f;
    font-weight: bold;
}

.uip-step-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ccc;
    margin-bottom: 10px;
    border: 2px solid #ccc;
}

.uip-progress-step.active .uip-step-dot {
    background-color: #d9534f;
    border-color: #d9534f;
}

.uip-progress-line {
    flex-grow: 1;
    height: 2px;
    background-color: #ccc;
    max-width: 200px;
}

/* Step Container */
.uip-step-container {
    max-width: 900px;
    margin: 0 auto;
}

/* Form Grid */
.uip-form-grid {
    border-top: 2px solid #333;
    border-bottom: 1px solid #ccc;
}

.uip-form-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.uip-form-row label {
    font-weight: bold;
    padding: 20px;
    background-color: #f9f9f9;
    border-right: 1px solid #eee;
}

.uip-form-field {
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.uip-form-field input[type="text"],
.uip-form-field input[type="email"] {
    width: 100%;
    max-width: 300px;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.uip-form-field.static {
    font-weight: bold;
}

.uip-id-note {
    font-size: 13px;
    color: #888;
    font-weight: normal;
}

.uip-required {
    color: #d9534f;
    margin-left: 5px;
}

.uip-inline-btn {
    padding: 8px 15px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
}


/* Summary Grid */
.uip-summary-grid {
    border-top: 2px solid #333;
    border-bottom: 1px solid #ccc;
    font-size: 15px;
}

.uip-summary-row {
    display: grid;
    grid-template-columns: 200px 1fr;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.uip-summary-row .label {
    background-color: #f9f9f9;
    font-weight: bold;
    padding: 15px;
    color: #333;
    border-right: 1px solid #eee;
}

.uip-summary-row span:last-child {
    padding: 15px;
}

/* Actions */
.uip-actions {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    gap: 15px;
}

.uip-actions.space-between {
    justify-content: space-between;
}

.uip-confirm-btn-large {
    width: 100%;
    max-width: 300px;
    padding: 15px;
    font-size: 16px;
    background-color: #d9534f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}


.uip-back-btn,
.uip-confirm-btn {
    padding: 12px 30px;
    font-size: 15px;
    border-radius: 4px;
    cursor: pointer;
}

.uip-back-btn {
    background-color: #fff;
    border: 1px solid #ccc;
    color: #333;
}

.uip-confirm-btn {
    background-color: #d9534f;
    border: 1px solid #d9534f;
    color: #fff;
}


/* Final Step */
.uip-step-container.centered-content {
    text-align: center;
    padding: 60px 0;
}

.uip-final-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 40px;
}

.uip-black-btn {
    padding: 15px 40px;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .user-info-edit-page {
        margin: 20px auto;
    }

    .uip-main-title {
        font-size: 28px;
    }

    .uip-form-row, .uip-summary-row {
        grid-template-columns: 150px 1fr;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .user-info-edit-page {
        padding: 0 15px;
        margin: 15px auto;
    }

    .uip-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .uip-main-title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .uip-progress-bar {
        display: none;
    }

    .uip-form-row, .uip-summary-row {
        grid-template-columns: 1fr;
    }

    .uip-form-row label, .uip-summary-row .label {
        background-color: transparent;
        padding: 10px 0;
        border-right: none;
        border-bottom: 1px solid #eee;
        font-size: 15px;
    }

    .uip-form-field {
        padding: 15px 0;
    }

    .uip-form-field input[type="text"],
    .uip-form-field input[type="email"] {
        max-width: 100%;
        height: 45px;
    }
    
    .uip-form-field {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }

    .uip-inline-btn {
        width: 100%;
        padding: 12px;
    }
    
    .uip-actions {
        flex-direction: column-reverse;
        gap: 10px;
        margin-top: 30px;
    }
    
    .uip-actions.space-between {
        flex-direction: column-reverse;
    }

    .uip-back-btn, .uip-confirm-btn, .uip-confirm-btn-large {
        width: 100%;
        max-width: 100%;
        padding: 15px;
    }
    
    .uip-step-container.centered-content {
        padding: 40px 0;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/UserInfoEditPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;;AAGA,iBAAiB;AACjB;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;;IAEI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;;AAGA,eAAe;AACf;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;QAClB,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".user-info-edit-page {\n    max-width: 1200px;\n    margin: 40px auto;\n    padding: 0 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n    color: #333;\n}\n\n.uip-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.uip-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.uip-main-title {\n    font-size: 32px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n/* Progress Bar */\n.uip-progress-bar {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 50px;\n    padding: 20px 0;\n    border-top: 1px solid #eee;\n    border-bottom: 1px solid #eee;\n}\n\n.uip-progress-step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #ccc;\n    font-size: 14px;\n    width: 150px;\n    text-align: center;\n}\n\n.uip-progress-step.active {\n    color: #d9534f;\n    font-weight: bold;\n}\n\n.uip-step-dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: #ccc;\n    margin-bottom: 10px;\n    border: 2px solid #ccc;\n}\n\n.uip-progress-step.active .uip-step-dot {\n    background-color: #d9534f;\n    border-color: #d9534f;\n}\n\n.uip-progress-line {\n    flex-grow: 1;\n    height: 2px;\n    background-color: #ccc;\n    max-width: 200px;\n}\n\n/* Step Container */\n.uip-step-container {\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n/* Form Grid */\n.uip-form-grid {\n    border-top: 2px solid #333;\n    border-bottom: 1px solid #ccc;\n}\n\n.uip-form-row {\n    display: grid;\n    grid-template-columns: 200px 1fr;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n}\n\n.uip-form-row label {\n    font-weight: bold;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-right: 1px solid #eee;\n}\n\n.uip-form-field {\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.uip-form-field input[type=\"text\"],\n.uip-form-field input[type=\"email\"] {\n    width: 100%;\n    max-width: 300px;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.uip-form-field.static {\n    font-weight: bold;\n}\n\n.uip-id-note {\n    font-size: 13px;\n    color: #888;\n    font-weight: normal;\n}\n\n.uip-required {\n    color: #d9534f;\n    margin-left: 5px;\n}\n\n.uip-inline-btn {\n    padding: 8px 15px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    white-space: nowrap;\n}\n\n\n/* Summary Grid */\n.uip-summary-grid {\n    border-top: 2px solid #333;\n    border-bottom: 1px solid #ccc;\n    font-size: 15px;\n}\n\n.uip-summary-row {\n    display: grid;\n    grid-template-columns: 200px 1fr;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n}\n\n.uip-summary-row .label {\n    background-color: #f9f9f9;\n    font-weight: bold;\n    padding: 15px;\n    color: #333;\n    border-right: 1px solid #eee;\n}\n\n.uip-summary-row span:last-child {\n    padding: 15px;\n}\n\n/* Actions */\n.uip-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    gap: 15px;\n}\n\n.uip-actions.space-between {\n    justify-content: space-between;\n}\n\n.uip-confirm-btn-large {\n    width: 100%;\n    max-width: 300px;\n    padding: 15px;\n    font-size: 16px;\n    background-color: #d9534f;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n\n.uip-back-btn,\n.uip-confirm-btn {\n    padding: 12px 30px;\n    font-size: 15px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.uip-back-btn {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    color: #333;\n}\n\n.uip-confirm-btn {\n    background-color: #d9534f;\n    border: 1px solid #d9534f;\n    color: #fff;\n}\n\n\n/* Final Step */\n.uip-step-container.centered-content {\n    text-align: center;\n    padding: 60px 0;\n}\n\n.uip-final-title {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 40px;\n}\n\n.uip-black-btn {\n    padding: 15px 40px;\n    background-color: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .user-info-edit-page {\n        margin: 20px auto;\n    }\n\n    .uip-main-title {\n        font-size: 28px;\n    }\n\n    .uip-form-row, .uip-summary-row {\n        grid-template-columns: 150px 1fr;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .user-info-edit-page {\n        padding: 0 15px;\n        margin: 15px auto;\n    }\n\n    .uip-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .uip-main-title {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    .uip-progress-bar {\n        display: none;\n    }\n\n    .uip-form-row, .uip-summary-row {\n        grid-template-columns: 1fr;\n    }\n\n    .uip-form-row label, .uip-summary-row .label {\n        background-color: transparent;\n        padding: 10px 0;\n        border-right: none;\n        border-bottom: 1px solid #eee;\n        font-size: 15px;\n    }\n\n    .uip-form-field {\n        padding: 15px 0;\n    }\n\n    .uip-form-field input[type=\"text\"],\n    .uip-form-field input[type=\"email\"] {\n        max-width: 100%;\n        height: 45px;\n    }\n    \n    .uip-form-field {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 10px;\n    }\n\n    .uip-inline-btn {\n        width: 100%;\n        padding: 12px;\n    }\n    \n    .uip-actions {\n        flex-direction: column-reverse;\n        gap: 10px;\n        margin-top: 30px;\n    }\n    \n    .uip-actions.space-between {\n        flex-direction: column-reverse;\n    }\n\n    .uip-back-btn, .uip-confirm-btn, .uip-confirm-btn-large {\n        width: 100%;\n        max-width: 100%;\n        padding: 15px;\n    }\n    \n    .uip-step-container.centered-content {\n        padding: 40px 0;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
